<template>
  <div class="page">
    <div v-if="model!= null">
      <van-panel class="panel-info">
        <div class="content">
          <div class="row">
            <span class="label">用户</span>
            <span style="display:flex;justify-content:center;align-items:center;">
              <img :src="user.headImgUrl" height="50px"  style="border-radius: 50%" width="50px" />
              <span style="margin-left: 10px">{{user.nickname}}</span>
            </span>
          </div>
          <div class="row">
            <span class="label">ID:</span>
            <span class="value">{{ model.id }}</span>
          </div>
          <div class="row">
            <span class="label">开始时间</span>
            <span class="value">{{
              formatDate(model.startTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
          </div>
          <div class="row">
            <span class="label">结束时间</span>
            <span class="value">{{
              formatDate(model.endTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
          </div>
          <div class="row" >
            <span class="label">用户要求</span>
            <span class="value">


              <van-tag
                v-if="model.options.clerkSex != null"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{
                  $store.state.ClerkSexEnum.getLabel(model.options.clerkSex)
                }}</van-tag
              >
              <van-tag
                v-if="model.options.clerkGrade != null"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{
                  $store.state.ClerkGradeMap[model.options.clerkGrade]
                }}</van-tag
              >
              <van-tag v-if="model.options.clerkGroup != null" color="#f2826a" plain size="medium" style="margin-right: 3px; margin-bottom: 5px" type="danger" >
            {{ $store.state.ClerkGroupMap[model.options.clerkGroup]}}
          </van-tag>
              <van-tag
                v-for="(item, index) in model.options.clerkTags"
                :key="index"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{ item }}</van-tag>
              <van-tag v-for="(item, index) in model.item.names" :key="index" color="#f2826a" plain size="medium" style="margin-right: 3px; margin-bottom: 5px" type="danger" >
            {{ item }}
          </van-tag>
            </span>
          </div>
          <div class="row">
            <span class="label">用户备注</span
            ><span class="value">{{ model.userMemo }}</span>
          </div>
          <div>
            <div>回应店员</div>
              <div v-for="(item, index) in clerkList " :key="index" style="margin: 10px 30px;display:flex;align-items:center;margin-left: 7 0px">
                <img :src="item.avatarUrl" height="50px" style="border-radius: 50%" width="50px"/>
                <div style="float: left;margin-left: 20px">
                  <van-tag plain type="primary">ID：{{ item.id }}</van-tag>
                  <div>{{ item.name }}</div>
                </div>
              </div>
          </div>
        </div>
      </van-panel>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Button,
  Cell, CellGroup,
  Dialog,
  Field,
  Icon,
  Panel,
  Tag,
  Toast, Uploader,
} from "vant";
import Decimal from "decimal.js";
import moment from "moment";
import VueClipboards from "vue-clipboards";
import { getInfo} from "@/api/kf/user_select_clerk_condition";

Vue.use(Panel)
  .use(Cell)
  .use(CellGroup)
  .use(Button)
  .use(Tag)
  .use(Icon)
  .use(Toast)
  .use(Dialog)
  .use(Uploader)
  .use(Field);

Vue.use(VueClipboards);

export default {
  name: "clerk-order-detail",
  components: {
  },

  data() {
    return {
      model: null,
      user: null,
      clerkList: null,
      btnConfirmDisabled: false,
    };
  },
  computed: {
    copyUserWechatId() {
      if (this.model) {
        return this.model.userWechatId;
      }
      return null;
    },
  },
  methods: {
    formatDate(date, format) {
      if (!date) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD";
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString();
      }
      return "";
    },
    // 格式化时间差
    formatTimeDiff(start, end, status) {
      start = moment(start);
      end = moment(end);
      const diffSeconds = end.diff(start, "seconds");
      if (status === 2 && diffSeconds < 1) {
        return '即将完成'
      }
      if (diffSeconds < 60) {
        return `${diffSeconds}秒`;
      }
      const diffMinutes = end.diff(start, "minutes");
      if (diffMinutes < 60) {
        return `${diffMinutes}分钟`;
      }
      const diffHours = end.diff(start, "hours");
      if (diffHours < 24) {
        return `${diffHours}小时`;
      }
      const diffDays = end.diff(start, "days");
      return `${diffDays}天`;
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: "加载中...",
      });
      getInfo(this.$route.params.id).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.model = data.userSelectClerkCondition;
          this.user = data.user;
          this.clerkList = data.clerkList;
        } else {
          Dialog.alert({
            title: "加载失败",
            message: data.msg,
          });
        }
      });
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
  },
};
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;

  .panel-info {
    margin-top: 10px;

    .content {
      font-size: 14px;
      padding: 10px 15px;

      .row {
        .user_head {
          position: relative;
          padding: 10px;
          .level {
            position: absolute;
            left: 50%;
            height: 10px;
            font-size: 10px;
            white-space: nowrap;
            bottom: 5px;
            transform: translateX(-50%);
          }

          .avatarFrame {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }

  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }

  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }

  .bottom-bar {
    padding: 10px 15px;
    /*background: #fff;*/
    /*box-shadow: 0 0 3px 0px #333;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
  }

  .commentBox {
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .imgStyle {
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }

  .screenshot {
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }

  .screenshotImg {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .module {
    margin-top: 15px;
    padding: 0px 15px;
    position: relative;

    /deep/ .van-cell {
      padding: 15px 0;
      background: transparent;
      font-size: 14px;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;

      &.module-title {
        padding-bottom: 0;
      }

      .van-cell__title {
        width: 90px;
        flex: none;
        box-sizing: border-box;
        font-weight: 600;
        color: #333333;
      }

      .van-cell__value {
        font-weight: 400;
        color: #999999;
      }

      &.van-cell--required {
        &::before {
          left: 0px;
        }
      }
    }
  }

  .image-uploader {
    /deep/ .van-uploader__wrapper {
      .van-uploader__preview {
        .van-uploader__preview-delete {
          top: 0;
          right: 0;
          color: var(--primary-color);
        }
      }
    }
  }
  .wx {
    height: 20px;
    line-height: 18px;
    background-color: #f87d23;
    border: 1px solid #f87d23;
    margin-right: 15px
  }

}
</style>
